import React from 'react';
import PrintText from './PrintText';
import { Field } from 'redux-form/immutable';
import { renderField } from './_FORM_FIELDS';

const Email = props => {
  const { classProperty, type, validations, value, isReadOne, ...rest } = props;
  return (
    <div>
      {isReadOne ? (
        <PrintText {...props} />
      ) : (
        <Field
          name={classProperty}
          component={renderField}
          type='email'
          validate={validations}
          value={value}
          fieldType={type}
          disabled={
            props.disableLayoutItem
          }
          {...rest}
        />
      )}
    </div>
  );
};

export default Email;
